import { render, staticRenderFns } from "./VueLoader.vue?vue&type=template&id=6950b4ee&scoped=true"
import script from "./VueLoader.vue?vue&type=script&lang=js"
export * from "./VueLoader.vue?vue&type=script&lang=js"
import style0 from "./VueLoader.vue?vue&type=style&index=0&id=6950b4ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6950b4ee",
  null
  
)

export default component.exports